import { useEffect, useState } from "react";
import Body from "./Body";
import PlusBtnIcon from "../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";

const TeamCreateSetup = () => {
  const [positionData, setPositionData] = useState([
    { position: "Team captain", color: "#3FB5FF" }, // Light Blue
    { position: "Team vice captain", color: "#5DA5D2" }, // Darker Blue
    { position: "Team member", color: "#A2A2A2" }, // Grey
    { position: "Class representative", color: "#FFBB00" }, // Yellow/Gold
  ]);
  const [addNewPositionModalStatus, setAddNewPositionModalStatus] =
    useState(false);
  const [teamInfoCardsData, setTeamInfoCardsData] = useState([
    {
      teamId: "team-001", // Unique identifier
      teamName: "Student coordination team",
      workingField: "Coordinate with management",
      teamMembers: [
        {
          name: "Aditya Verma",
          id: "SM0515090",
          class: "5/C",
          designation: "Management",
          image: "https://randomuser.me/api/portraits/men/19.jpg",
          isCaptain: true,
          isViceCaptain: false,
        },
      ],
    },
  ]);
  const handelUpdateCardData = (updatedData) => {
    setTeamInfoCardsData((prev) =>
      prev.map((team) =>
        team.teamId === updatedData.teamId ? updatedData : team
      )
    );
  };
  const addButtonElement = () => {
    return (
      <div className="flex-col align-left justify-start">
        <button
          type="button"
          className="addNewFieldBtn"
          onClick={() =>
            setTeamInfoCardsData((prev) => [
              ...prev,
              {
                teamId: new Date().getMilliseconds(),
                teamName: "",
                workingField: "",
                teamMembers: [],
              },
            ])
          }
        >
          <img src={PlusBtnIcon} alt="add icon" />
          <span>
            Create
            <br /> another
          </span>
        </button>
      </div>
    );
  };
  const [isAddable, setIsaddable] = useState(false);
  useEffect(() => {
    const isAddable = teamInfoCardsData?.some(
      (_data) =>
        _data?.teamId === "" ||
        _data?.teamName === "" ||
        _data?.teamMembers?.length === 0
    );

    setIsaddable(!isAddable);
  }, [teamInfoCardsData]);

 const handelNewPosition = (data) => {
  console.log(data);
  
  setPositionData((prev) => {
    const exists = prev.some(
      (item) =>
        item?.position?.toString().trim().toLowerCase() === data?.position?.toString().trim().toLowerCase()
    );
    return exists ? prev : [...prev, data];
  });
};

  const _this = {
    positionData,
    setPositionData,
    teamInfoCardsData,
    setTeamInfoCardsData,
    handelUpdateCardData,
    addNewPositionModalStatus,
    setAddNewPositionModalStatus,
    addButtonElement,
    isAddable,
    setIsaddable,
    handelNewPosition,
  };
  return <Body {..._this} />;
};

export default TeamCreateSetup;
